module.exports = __webpack_public_path__ + "img/logo.a9a80ea2.png";